import React from 'react';

// IMPORT STYLES
import './PersonCard.css';

// IMPORT CONSTANTS
import {
  PROF,
  LASTNAME,
  NAME,
  PHONE
}
from './constants';

// IMPORT COMPONENTS
import PersonPhoto from '../PersonPhoto/PersonPhoto';
import PersonMainInfo from '../PersonMainInfo/PersonMainInfo';

function PersonCard() {

  return(
    <div className='person-card'>
      <PersonPhoto />
      <PersonMainInfo prof={PROF} lastname={LASTNAME} name={NAME} phone={PHONE} />
    </div>
  );
}
export default PersonCard;
